import { HttpClient } from "@angular/common/http";
import { PowerBiCfgService } from "./powerbi-cfg.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PowerBiReportAccessDataModel } from "../models/powerbi-report-access-data.model";

@Injectable({
    providedIn: 'root'
})
export class PowerBiService {

    constructor(private http: HttpClient, private powerBiCfgService: PowerBiCfgService) { }

    /**
     * Obtiene los datos del Report de PowerBi de la Home
     * @returns Datos de Report y token de acceso
     */
    getReportAccessData(): Observable<PowerBiReportAccessDataModel> {
        const cfg = this.powerBiCfgService.getCfg();
        const url = `${cfg.powerBi.reportEndpointPattern}`;

        return this.http.get<PowerBiReportAccessDataModel>(url);
    }
}
